import { useMasterData } from '../../../hooks/api/useMasterData'
import { useDispatch, useSelector } from 'react-redux'
import { clearSelectedSetup, selectSetupName } from '../../../features/system/systemSlice'
import { setSetup } from '../../../features/setup/setupSlice'
import SetupTHead from '../theads/SetupTHead'
import { setUpCategory } from '../../../data/admin-data'
import SetupCategoriesTBody from '../tbody/SetupCategoriesTBody'
import SetupHeader from '../headers/SetupHeader'

export default function SetupCategory() {

    const dispatch = useDispatch()
    const { getCategory, isErrorGetCategory, isLoadingGetCategory, errorMessageGetCategory } = useMasterData()
    const selectedSetupName = useSelector(selectSetupName)
    const isCurrentlyLoading  = isLoadingGetCategory 

    return (
        <>
            <SetupHeader
                onClick={() => dispatch(clearSelectedSetup())}
                handleClickNew={() => dispatch(setSetup({ type: 'show', value: 'setUpCategory'}))}
                selectedSetupName={selectedSetupName}
            />
            <div className='h-full overflow-hidden bg-white rounded border'>
                <div className='overflow-y-auto h-full'>
                    <table className='min-w-max w-full'>
                        <SetupTHead data={setUpCategory}/> 
                        <SetupCategoriesTBody
                            data={getCategory}
                            isLoading={isCurrentlyLoading}
                            isError={isErrorGetCategory}
                            errorMessage={errorMessageGetCategory}
                            isEmpty={getCategory.length === 0}
                        />
                    </table>
                </div>
            </div>
        </>
    )
}
